import { useTrans } from '@/shared/hooks/useTranslation';
import { useScopeCrumbs } from '@/viewmodel/features/project/hooks/useScopeCrumbs';
import { datasetBreadcrumbs } from '@/viewmodel/features/project/mappers/scopeBreadcrumbs';
import type { BreadcrumbItem } from '@/viewmodel/shared/breadcrumbs';
import { useLocation, useSearchParams } from 'react-router-dom';

export function useDatasetBreadcrumbsViewModel(
  currentPageLabel: string | undefined,
): BreadcrumbItem[] {
  const { t } = useTrans();
  const { pathname } = useLocation();
  const [searchParams] = useSearchParams();
  const isCreateMode = searchParams.get('action') === 'create';
  return datasetBreadcrumbs(pathname, { isCreateMode, currentPageLabel }, useScopeCrumbs(), t);
}
